[
  {
    "id": "SR-M8P-CAISSIERE-V01",
    "module": "SpellingRegel",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-CAISSIERE",
    "conceptId": "french_loanword_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "caissière",
      "cassière",
      "caissiere",
      "kaisjère"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'caissière'. Dit is een Frans leenwoord met 'ai' (niet 'a'), een dubbele 's', en een accent grave op de 'e' (è). Onthoud: caisse (Frans voor kas) + ière.",
    "distractorExplanations": {
      "1": "Hier ontbreekt de 'i' in 'cai'. Het woord komt van het Franse 'caisse'.",
      "2": "Zonder accent grave is de spelling onvolledig. Het accent is verplicht: caissière.",
      "3": "Dit is een fonetische schrijfwijze. Franse leenwoorden behouden hun originele spelling."
    }
  },
  {
    "id": "SR-M8P-GUERRILLA-V01",
    "module": "SpellingRegel",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-GUERRILLA",
    "conceptId": "foreign_loanword_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "guerrilla",
      "guerilla",
      "guerrillia",
      "gerilla"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'guerrilla' — een Spaans leenwoord. Het heeft een dubbele 'r' én een dubbele 'l'. Onthoud: gue-rri-lla.",
    "distractorExplanations": {
      "1": "Hier ontbreekt één 'r'. Het woord heeft zowel dubbel-r als dubbel-l.",
      "2": "Hier staat een extra 'i' achter de dubbele 'l'. Het eindigt op -lla, niet -llia.",
      "3": "Hier ontbreken de 'ue' en een 'r'. Het begint met 'gue-', niet 'ge-'."
    }
  },
  {
    "id": "SR-M8P-FAILLISSEMENT-V01",
    "module": "SpellingRegel",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-FAILLISSEMENT",
    "conceptId": "foreign_loanword_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "faillissement",
      "failissement",
      "faillisement",
      "faljissement"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'faillissement'. Dit woord heeft een dubbele 'l' én een dubbele 's'. Onthoud: failli (Frans voor bankroet) + ssement.",
    "distractorExplanations": {
      "1": "Hier ontbreekt één 'l'. Het woord heeft dubbel-l: fai-lli-ssement.",
      "2": "Hier ontbreekt één 's'. Het woord heeft dubbel-s: faillis-se-ment.",
      "3": "De 'll' wordt niet als 'lj' geschreven. Het is een Frans leenwoord met dubbele 'l'."
    }
  },
  {
    "id": "SR-M8P-PARALLEL-V01",
    "module": "SpellingRegel",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-PARALLEL",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "parallel",
      "parralel",
      "paralel",
      "parallell"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'parallel'. Het heeft één 'r' en een dubbele 'l' aan het eind. Onthoud: pa-ra-llel (de dubbele letter zit aan het eind, niet in het midden).",
    "distractorExplanations": {
      "1": "Hier staat de dubbele letter op de verkeerde plek. Het is één 'r', niet twee.",
      "2": "Hier ontbreekt een 'l'. Het woord eindigt op dubbel-l: -llel.",
      "3": "Hier staan drie l'en. Het woord heeft er maar twee: para-llel."
    }
  },
  {
    "id": "SR-M8P-REPRESAILLE-V01",
    "module": "SpellingRegel",
    "difficulty": 304,
    "difficultyTier": 16,
    "levelCode": "M8+",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-REPRESAILLE",
    "conceptId": "french_loanword_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "represaille",
      "repressaille",
      "represaile",
      "reprisaille"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'represaille'. Dit Franse leenwoord heeft één 's' en eindigt op '-aille' (spreek uit: aj-je). Onthoud: repre-saille.",
    "distractorExplanations": {
      "1": "Hier staat een dubbele 's', maar het woord heeft er maar één.",
      "2": "Hier ontbreekt een 'l'. De uitgang is '-aille', niet '-aile'.",
      "3": "De eerste lettergreep is 're-pre', niet 're-pri'."
    }
  }
]